import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-leftnav-registration',
  templateUrl: './app-leftnav-registration.component.html',
  styleUrls: ['./app-leftnav-registration.component.scss']
})
export class AppLeftnavRegistrationComponent  {

  @Input() step = '';
  constructor() { }


}
